module.exports = __webpack_public_path__ + "media/images/tiktok-6d6dbda5ad5cad6d55b9dc5380b63d6c.svg";